/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store/store';
import CommandBar from './AccessMediator/CommandBar';
import RightColumn from './AccessMediator/RightColumn';
import LeftColumn from './AccessMediator/LeftColumn';
import Color from '../../../core/libraries/Color';
import _ from 'lodash';
import Helper from '../../../core/libraries/Helper';
import Constants from '../../../core/libraries/Constants';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import { IUserProfile } from '../../Auth/types';
import { ReportStatus } from '../types';
import { changeMode } from '../actions';
import { confirmDialog } from '../../Dialog/actions';

interface AccessMediatorProps {
    userProfile: IUserProfile | undefined,
    report: any,
    status: string,
    changeMode: typeof changeMode,
    confirmDialog: typeof confirmDialog,
    match: any,
};
// Declined, Pending, Published
class AccessMediator extends React.Component<AccessMediatorProps, any> {

    constructor(props: AccessMediatorProps) {
        super(props);
        this.hasPermissionOnDocument = this.hasPermissionOnDocument.bind(this);
    }

    componentDidMount() {
        const parameters: any = this.props.match.params;
        const mode = parameters["mode"];
        const { status, changeMode, confirmDialog } = this.props;
        if (this.hasPermissionOnDocument() === false && status === ReportStatus.PUBLISHED) {
            this.props.changeMode(Constants.ACCESS_MEDIATOR_MODE.VIEW);
        }
        if (_.isEqual(mode?.toLocaleLowerCase(), Constants.ACCESS_MEDIATOR_MODE.EDIT.toLocaleLowerCase())) {
            switch (status) {
                case ReportStatus.PENDING:
                case ReportStatus.PUBLISHED:
                    if (this.hasPermissionOnDocument()) {
                        changeMode(Constants.ACCESS_MEDIATOR_MODE.EDIT);
                    }
                    break;
                case ReportStatus.DECLINED:
                    if (this.hasPermissionOnDocument(true)) {
                        changeMode(Constants.ACCESS_MEDIATOR_MODE.EDIT);
                    }
                    break;
                default:
                    confirmDialog(Constants.MESSAGE_NO_SUFFICIENT_PERMISSION, Constants.MESSAGE_CONTACT_MAILBOX, true);
                    changeMode(Constants.ACCESS_MEDIATOR_MODE.VIEW);
                    break;
            }
        }
        if (status === ReportStatus.DECLINED && this.hasPermissionOnDocument(true)) {
            changeMode(Constants.ACCESS_MEDIATOR_MODE.EDIT);
        }
        if (status === ReportStatus.PENDING && this.hasPermissionOnDocument()) {
            changeMode(Constants.ACCESS_MEDIATOR_MODE.EDIT);
        }
    }

    render() {
        const { report, status } = this.props
        if ((!!report)) {
            return (
                <React.Fragment>
                    {<div className="ms-Grid">

                        {/* WorkOn Info */}
                        {(status === ReportStatus.PENDING) &&
                            <div className="ms-Grid-col ms-sm12">
                                <RbLabel style={{ fontSize: "16px", color: Color.GREEN }}>
                                    Pending Approval. You can check the status of the approval directly in WorkOn&nbsp;
                                    <span style={{ color: "#0000ff", cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                                        Helper.openNewTab("need to handle" + report.WorkflowId);
                                    }}>
                                        {report.WorkflowId}
                                    </span>
                                </RbLabel>
                            </div>}
                        {(status === ReportStatus.DECLINED) &&
                            <div className="ms-Grid-col ms-sm12">
                                <RbLabel style={{ fontSize: "16px", color: Color.RED }}>
                                    The upload was declined.{!!this.hasPermissionOnDocument(true) && " You can restart it if needed."}
                                </RbLabel>
                            </div>}
                        {/* Left column */}
                        <div className="ms-Grid-col ms-lg12 ms-xl6">
                            <LeftColumn hasAdminPermission={this.hasPermissionOnDocument(true)} />
                        </div>

                        {/* Right column */}
                        <div className="ms-Grid-col ms-lg12 ms-xl6">
                            <RightColumn hasAdminPermission={this.hasPermissionOnDocument(true)} />
                        </div>

                        {/* Command Bar */}
                        <div className="ms-Grid-col ms-sm12">
                            <CommandBar hasAdminPermission={this.hasPermissionOnDocument(true)} />
                        </div>
                    </div>}
                </React.Fragment>
            );
        }
        return null;
    }

    hasPermissionOnDocument(includeSubmitter: boolean = false): boolean {
        if (!!this.props.userProfile) {
            return Helper.checkHasPermissionOnDocument(this.props.report, this.props.userProfile, includeSubmitter) || false;
        }
        return false
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
    report: state.accessMediator.report,
    status: state.accessMediator.status,
});

export default connect(mapStateToProps, {
    changeMode,
    confirmDialog,
})(AccessMediator);